import { Link } from 'react-router';
import { BuildingOffice2Icon } from '@heroicons/react/24/outline';
import DashboardLayout from '../components/DashboardLayout';

// Placeholder for the LLC formation wizard flow (separate ticket).
export default function LlcSetupPage() {
  return (
    <DashboardLayout>
      <div className="px-10 py-8">
        <nav
          className="mb-7 flex items-center gap-2 text-[12px]"
          style={{ color: 'var(--dash-text-faint)' }}
        >
          <Link
            to="/"
            style={{ color: 'var(--dash-text-faint)' }}
            className="hover:underline"
          >
            Dashboard
          </Link>
          <span>›</span>
          <Link
            to="/trading"
            style={{ color: 'var(--dash-text-faint)' }}
            className="hover:underline"
          >
            DAG Trading
          </Link>
          <span>›</span>
          <span style={{ color: 'var(--dash-text-muted)' }}>LLC Setup</span>
        </nav>

        <div
          className="mx-auto max-w-[560px] rounded-xl p-10"
          style={{
            background: 'var(--dash-card)',
            border: '1px solid var(--dash-border)',
          }}
        >
          <div className="mb-7 inline-flex">
            <div className="dash-service-icon flex h-14 w-14 items-center justify-center rounded-xl">
              <BuildingOffice2Icon className="h-6 w-6" />
            </div>
          </div>

          <h1
            className="mb-3 font-serif text-[28px] font-medium leading-snug"
            style={{ color: 'var(--dash-text)' }}
          >
            LLC setup starts here
          </h1>
          <p
            className="mb-8 text-[14px] leading-relaxed"
            style={{ color: 'var(--dash-text-muted)' }}
          >
            This is where the real LLC formation flow would begin.
          </p>

          <Link
            to="/trading"
            className="inline-flex items-center gap-1.5 text-[13px] font-medium transition-colors"
            style={{ color: 'var(--dash-text-muted)' }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.color = 'var(--dash-text)')
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.color = 'var(--dash-text-muted)')
            }
          >
            ← Back to DAG Trading
          </Link>
        </div>
      </div>
    </DashboardLayout>
  );
}
